/* eslint-disable no-useless-constructor,react/destructuring-assignment */
// Copyright (c) 2016 Deere & Company

import './pin-search.scss';
import React, { Component } from 'react';
import BusyCounterLoadingIndicator from '../../../../sharedmodules/components/busyCounter/busy-counter-loading-indicator';
import { FormattedMessage } from 'react-intl';
import MeasurementReading from '../../shared/state/measurement-reading';
import Modal from '../../../../sharedmodules/state/modal';
import NewTransfer from '../../new-transfer/components/new-transfer';
import PinSearchInputField from './pin-search-input-field';
import PropTypes from 'prop-types';
import Transfer from '../../new-transfer/state/transfer';

class PinSearchSettings extends Component {

    constructor(props) {

        super(props);
        this.state = {
            isDealerTransfer: false,
            pin: '',

        };

    }

    handleExecute = (pinDetails, props) => {

        this.props.actions.resetNewTransfer();
        this.props.actions.updateAccountLookup('');
        this.props.actions.pinSearchData(props.auth.getAccessToken, pinDetails);
        this.props.actions.readLatestPerUnitMeasurements(props.auth.getAccessToken, pinDetails);
        this.setState({ isDealerTransfer: true });
        this.setState({ pin: pinDetails.pin });

    };

    handleReset = () => {

        this.props.actions.resetPinSearchData();
        this.props.actions.updateAccountLookup('');
        this.setState({ isDealerTransfer: false });

    }

    render() {

        const { busyCounter, pinSearchResult } = this.props;

        return (
            <section className="dealer-settings">
                <section className="dealer-settings-panel">
                    <BusyCounterLoadingIndicator busyCounter={busyCounter} />
                    <div className="dealer-settings-header">
                        <h5>
                            <FormattedMessage id="PIN_SEARCH_INFORMATION" />
                        </h5>
                    </div>
                    <PinSearchInputField
                        handleExecute={
                            (pinDetails) => this.handleExecute(pinDetails, this.props)}
                        handleReset={() => this.handleReset()}
                    />
                    {this.state.isDealerTransfer && pinSearchResult.pin !== '' && (
                        <NewTransfer
                            accountLookup={this.props.accountLookup}
                            actions={this.props.actions}
                            auth={this.props.auth}
                            busyCounter={this.props.busyCounter}
                            dealerSearchModal={this.props.dealerSearchModal}
                            isAmountOfUseModalOpen={this.props.isAmountOfUseModalOpen}
                            measurementReadings={this.props.measurementReadings}
                            newTransfer={this.props.newTransfer}
                            newTransferStatusChangeModal={this.props.newTransferStatusChangeModal}
                            pin={this.state.pin}
                            product={pinSearchResult}

                        />
                    )}
                </section>
            </section>
        );

    }

}

PinSearchSettings.displayName = 'PinSearchSettings';
PinSearchSettings.propTypes = {
    accountLookup: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    busyCounter: PropTypes.bool.isRequired,
    dealerSearchModal: PropTypes.instanceOf(Modal).isRequired,
    getPinSearchData: PropTypes.func,
    isAmountOfUseModalOpen: PropTypes.bool.isRequired,
    measurementReadings: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    newTransfer: PropTypes.instanceOf(Transfer).isRequired,
    newTransferStatusChangeModal: PropTypes.instanceOf(Modal).isRequired,
    pinSearchResult: PropTypes.object,
    resetPinSearchData: PropTypes.func,
};

export default PinSearchSettings;
